import { render } from "./MyStepWizard2.vue?vue&type=template&id=57715b0d&scoped=true"
import script from "./MyStepWizard2.vue?vue&type=script&lang=js"
export * from "./MyStepWizard2.vue?vue&type=script&lang=js"

import "./MyStepWizard2.vue?vue&type=style&index=0&id=57715b0d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57715b0d"]])

export default __exports__